var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2932 8.12236C47.2932 6.62658 48.5063 5.41561 50 5.41561V0H16.2447C7.27215 0 0 7.27215 0 16.2447H50V10.8291C48.5042 10.8291 47.2932 9.61603 47.2932 8.12236Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9873V24.403C1.49578 24.403 2.70675 25.616 2.70675 27.1097C2.70675 28.6034 1.49367 29.8165 0 29.8165V35.2321H33.7553C42.7278 35.2321 50 27.9599 50 18.9873H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f48825a8b9262ada8dd244b732854550.svg";
export { ForwardRef as ReactComponent };